import { ArrowUpRight, MessageCircle } from "lucide-react";
import { whatsappLink, openWhatsApp } from "@/lib/site";

export default function FinalCTA() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      data-testid="final-cta-section"
      className="relative py-32 md:py-48 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110vw] h-[110vw] ambient-radial pointer-events-none"
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-b from-transparent via-black/0 to-black pointer-events-none"
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center reveal">
        <h2
          data-testid="final-cta-headline"
          className="font-serif font-light text-white text-5xl sm:text-6xl lg:text-8xl leading-[1] tracking-tight text-balance"
        >
          Your financial future
          <br />
          <span className="italic text-rolex-light">starts now.</span>
        </h2>
        <p className="mt-10 text-lg md:text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed font-light">
          One conversation can change the next thirty years. Choose your path.
        </p>

        <div className="mt-14 flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollTo("#calendly-embed")}
            data-testid="final-cta-get-started"
            className="group inline-flex items-center justify-center gap-2 bg-[#006241] hover:bg-[#0a8a5e] text-white px-10 py-5 rounded-full text-base font-medium transition-all duration-300 shadow-[0_0_60px_rgba(0,98,65,0.45)] hover:shadow-[0_0_80px_rgba(0,98,65,0.7)]"
          >
            Get Started
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.preventDefault();
              openWhatsApp();
            }}
            data-testid="final-cta-whatsapp"
            className="inline-flex items-center justify-center gap-2 bg-transparent border border-white/15 hover:border-white/40 text-white hover:bg-white/[0.04] px-10 py-5 rounded-full text-base font-medium transition-all duration-300"
          >
            <MessageCircle className="h-4 w-4" />
            Chat on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
